import NavBar from '../Components/NavBar';
import Footer from '../Components/Footer';

export default function Authenticated({ user, header, children }) {
    return (
        <div className="h-full bg-slate-100">
            <div className="min-h-screen">

                <NavBar user={user} header={header} />

                <main>
                    {children}
                </main>

            </div>
            <Footer />
        </div>
    );
}
